@import '../../styles/modals.css';
@import '../../styles/buttons.css';

.payment-methods-wrapper {
  position: relative;
}

  .payment-methods-wrapper.scroll:after {
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-image: linear-gradient(to bottom, rgba(248,249,250, 0), rgba(248,249,250, 1) 90%);
    width: 100%;
    height: 40px;
  }

.payment-methods {
  max-height: 180px;
  overflow-y: auto;
}

  .scroll .payment-methods {
    padding-bottom: 20px;
  }

.payment-method {
  display: flex;
  padding: 10px 0;
}

tambr-payment-method {
  cursor: default;
  flex: 1;
}

.payment-method-radio-button {
  display: block;
  width: 15px;
  height: 15px;
  margin: 1px 25px 0px 5px;
  background-size: cover;
}

.tambr-action-buttons .second-line {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 10px;
}